import type { ColumnDef } from "@tanstack/react-table";
import type { Experiment } from "@/types/experiment";
import { ExperimentStatusBadge } from "./experiment-status-badge";
import {
  ExperimentActions,
  type ExperimentAction,
} from "./experiment-actions";
import { formatDate } from "@/lib/format";

export function getExperimentColumns(
  onAction: (experiment: Experiment, action: ExperimentAction) => void,
): ColumnDef<Experiment>[] {
  return [
    {
      accessorKey: "key",
      header: "Key",
      cell: ({ row }) => (
        <code className="rounded bg-muted px-1.5 py-0.5 text-xs font-mono">
          {row.original.key}
        </code>
      ),
    },
    {
      accessorKey: "name",
      header: "실험명",
      cell: ({ row }) => (
        <div className="max-w-[200px] truncate text-sm font-medium" title={row.original.name}>
          {row.original.name}
        </div>
      ),
    },
    {
      accessorKey: "status",
      header: "상태",
      cell: ({ row }) => (
        <ExperimentStatusBadge status={row.original.status} />
      ),
    },
    {
      accessorKey: "variants",
      header: "Variants",
      cell: ({ row }) => (
        <div className="flex gap-1 text-xs text-muted-foreground">
          {row.original.variants.map((v) => (
            <span key={v.key} className="rounded bg-muted px-1.5 py-0.5">
              {v.key}: {(v.weight / 100).toFixed(1)}%
            </span>
          ))}
        </div>
      ),
    },
    {
      accessorKey: "createdAt",
      header: "생성일",
      cell: ({ row }) => (
        <div className="whitespace-nowrap text-sm">
          {formatDate(row.original.createdAt, { format: "short" })}
        </div>
      ),
    },
    {
      id: "actions",
      header: "작업",
      cell: ({ row }) => (
        <ExperimentActions experiment={row.original} onAction={onAction} />
      ),
    },
  ];
}
